import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { MergePurgeParameters } from './types/merge-purge-parameters.type';
import type { SeedCount } from './types/seed-count.type';

/**
 * Retrieves the seed count for a merge-purge operation using the provided HTTP client instance and search parameters.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param searchParams - The parameters for the merge-purge operation.
 * @returns A promise that resolves to an {@link OperationResultWithData}
 * containing an array of {@link SeedCount} objects.
 * @throws Throws an error if the request fails.
 */
export const getSeedCount = async (instance: KyInstance, searchParams: MergePurgeParameters) => {
  try {
    return await instance
      .get<OperationResultWithData<SeedCount[]>>(Uri.reports.mergePurge.seedCount, {
        searchParams,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
